// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1o2B1","sendOtp":"AuthorizeToLogin_sendOtp__15qGJ"};